<div [style.background]="barColor" class="supportBox">
  <p *ngIf="isShared" style="text-align: center; color: white; font-size: 11px">Shared project</p>
  <p *ngIf="!isShared" style="text-align: center; color: white; font-size: 11px">{{ supportInfo }}</p>
</div>
